module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d6fcb8f7d1122787171dd831d1263e71.png";